export const modalCheckClasses = [
  'story-view-modal-container',
  'story-view-modal-ai-generated',
  'sentence-starter-modal-container',
  'differentiation-modal-container',
  'createSentenceStarterForm',
  'toggleDrawer',
  'workbookPrintScreen',
  'activityStandardsPopup',
  'sentenceViewPopup',
  'storyAIPopup',
  'story-widget-container',
  'notes-widget',
];

export const isModalOpenByClass = () => {
  if (typeof document === 'undefined' || !modalCheckClasses.length) {
    return false;
  }
  const found = modalCheckClasses.some(
    (cls) => document.getElementsByClassName(cls).length > 0
  );
  return found;
};
